import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@deal/components'
import { GuestCartConsumer } from '#src/containers/Cart'
import { normalizeSellablePricing } from '#src/services/sellable'
import { GuestSellablesComponent } from '../../GuestSellables.generated'
import numeral from 'numeral'
import styles from './styles.css'

const Footer: React.FC = () => (
  <GuestCartConsumer>
    {({ data }) => {
      if (data && data.order.length > 0) {
        const guestSellables = data.order

        return (
          <GuestSellablesComponent
            variables={{
              ids: guestSellables.map(guestSellable => guestSellable.id)
            }}
          >
            {({ data }) => {
              if (data && data.sellables) {
                const sellableTotal = data.sellables.reduce((sum, sellable) => {
                  const normalizedPricing = normalizeSellablePricing(sellable)
                  const sellablePrice = normalizedPricing && normalizedPricing.price

                  // Check the quantity in the local state to see if we need to multiply it
                  const sellableInStorage = guestSellables.find(
                    guestSellable => guestSellable.id === sellable.id
                  )

                  return sellablePrice
                    ? sellablePrice.amount * (sellableInStorage ? sellableInStorage.quantity : 1) +
                        sum
                    : sum
                }, 0)

                return (
                  <div className={styles.module}>
                    <div className={styles.row}>
                      <div className={styles.label}>Estimated Total</div>
                      <div className={styles.value}>{numeral(sellableTotal).format('$0,0.00')}</div>
                    </div>
                    <div className={styles.buttons}>
                      <Link
                        to="/guest-checkout"
                        className={styles.button}
                        data-testid="guest-cart-secure-checkout"
                      >
                        <Button className={styles.button}>Secure checkout</Button>
                      </Link>
                    </div>
                  </div>
                )
              }

              return null
            }}
          </GuestSellablesComponent>
        )
      }

      return (
        <div className={styles.module}>
          <div className={styles.row}>
            <div className={styles.label}>Estimated Total</div>
            <div className={styles.value}>$0.00</div>
          </div>
          <div className={styles.buttons}>
            <Button className={styles.button} disabled>
              Secure checkout
            </Button>
          </div>
        </div>
      )
    }}
  </GuestCartConsumer>
)

export default Footer
